<template>
  <div class="main">
    <div class="title-bar row no-gutters">
      <div class="col-12 mb-4 col-sm-8 mb-lg-2">
        <h1 class="mb-2">Trainer Bio</h1>
        <a class="btn-back" href="javascript:history.go(-1);">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Go Back</span>
        </a>
      </div>
      <div class="col-12 col-sm-4 text-center text-sm-right">
        <a class="btn btn-primary mt-0 mb-4 mt-sm-4 mb-sm-0"
           :href="route('catalog.trainer.edit', { company: company.id })"
           v-if="$root.isAdmin">
          Edit
        </a>
      </div>
    </div>

    <div class="row no-gutters py-4 px-3 ml-3">
      <div class="col-md-6">
        <!-- COMPANY DETAILS -->
        <h3 class="text-lg-left">{{ company.name }}</h3>
        <p v-html="company.address"></p>
        <div v-html="company.meta.bio" class="mt-2 mb-4"></div>

        <hr/>
        <div class="py-4">
          <!-- TRAINER DETAILS -->
          <h3 class="mb-4 font-weight-bold">Our Trainers</h3>
          <div v-for="user in company.trainers" class="trainer">
            <div class="row mb-2">
              <div class="col-2 font-weight-bold">Name:</div>
              <div class="col-10">{{ user.name }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-2 font-weight-bold">Email:</div>
              <div class="col-10">{{ user.email }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-2 font-weight-bold">Phone:</div>
              <div class="col-10">{{ user.phone }}</div>
            </div>
            <div v-html="user.meta.bio" class="mt-3 mb-4"></div>
            <hr/>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-5 bg-white">
        <h3 class="p-4 border-bottom font-weight-bold">Our Courses</h3>
        <div v-if="courses?.length">
          <template v-for="course in courses">
            <template v-if="course.can_view">
              <div class="py-2 px-4">
                <h4 class="mt-1">
                  Course Name:
                  <a :href="route('catalog.course', {course: course.id})">{{ course.name }}</a>
                </h4>
                <div class="mb-4">Course: Type: {{ course.type === 'CLASSROOM' ? 'Classroom' : 'Online' }}</div>

                <a v-if="course.type === 'CLASSROOM' && ($root.isDistributor || $root.isAdmin)"
                   :href="route('event-request.create', {course: course.id})"
                   class="btn btn-primary">
                  Request an Event
                </a>

                <a v-else-if="course.type === 'ONLINE' && course.can_launch"
                   :href="course.launch_url"
                   class="btn btn-primary"
                   target="_blank">
                  Launch {{ course.launch_url }}
                </a>
                <div v-else-if="course.type === 'ONLINE'">
                  <a :href="route('enroll.online.course.self', { course: course.id })"
                     class="btn btn-primary mr-2">
                    Register Self
                  </a>
                  <a :href="route('enroll.online.course.others', { course: course.id })"
                     class="btn btn-primary">
                    Register Others
                  </a>
                </div>
                <hr/>
              </div>
            </template>
          </template>
        </div>
        <div v-else class="mt-5 text-center">
          <p>No Courses Available</p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: {type: Object},
    courses: {type: Array}
  },
}
</script>
<style>
.trainer .col-2 {
  font-size: 13px;
}
</style>